import React, { useState, useContext, useEffect } from 'react';
import {IProps, IState} from './types';
import * as S from './styles';
import actions from '@state/actions';
import { IParsedTreeChange } from '@state/parsedTrees/types';
import { Context } from './../../../Context';
import { useDispatch } from 'react-redux';
import Loading from '@components/Loading';
import { AuthContext } from '@utils/DOIgnition/AuthContext';
import { SmallCloseIcon } from '@assets/icons/smallCloseIcon';
import { CloseIcon } from '@assets/icons/closeIcon';

const VersionHistoryPicker:React.FC<IProps> = (props) => {      
    const context = useContext(Context);
    const [versionsList, setVersionsList] = useState<IParsedTreeChange[] | undefined>(undefined);    
    const [versionsListView, setVersionsListView] = useState<IParsedTreeChange[]>([]);   
    const [versionSelected, setVersionSelected] = useState<IParsedTreeChange | undefined>(undefined);    
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const authContext = useContext(AuthContext);
    const [page, setPage] = useState<number>(0);
    const pageSize =20;

    const dispatch = useDispatch();

    const fetchParsedTreeChanges = (start:number, length:number) => {
        setIsLoading(true);    
        return new Promise((resolve, reject) => {                  
          dispatch(actions.parsedTrees.fetchParsedTreeChanges(context.parsedTreeInfo.id,start,length , true, (result, error) => {                    
            setIsLoading(false);        
            if (error) reject(error)
            else {                
              resolve(result)}
          }))
        });
      }

      const getParsedTreeChange = (id:string) => {        
        return new Promise((resolve, reject) => {                  
          dispatch(actions.parsedTrees.getParsedTreeChange(id, (result, error) => {                    
            if (error) reject(error)
            else {  
              resolve(result)}
          }))
        });
      }

    async function getParsedTreeChanges(start:number){              
        const data: any = await fetchParsedTreeChanges(start, pageSize)         
        if (data) setVersionsList(data);  
      }

    async function selectVersion(id:string){
        const data: any = await getParsedTreeChange(id)         
        if (data) setVersionSelected(data);  
      }
    
      useEffect(() => {                
          context.onSelectEditMode(false);
          getParsedTreeChanges(0);        
      }, []);

      useEffect(() => {        
         
 
        if (versionsList && versionsList.length>0 )
        {                             
          let newarray = [...versionsListView, ...versionsList];            
          setVersionsListView(newarray);
        }
        
      },[versionsList])

    useEffect(() => {                
        if (versionSelected)
        {          
          context.onSelectVersion(versionSelected);
        }
    }, [versionSelected]);

    const getVersionText=( change: IParsedTreeChange )=>{
      
      return (
        <>          
          {new Intl.DateTimeFormat('en-US',{day:'2-digit', month:'2-digit', year:'2-digit', hour:'2-digit', minute:'2-digit'}).format(new Date(change.createdDate))} by {change.createdBy.name}
        </>
      )

    }

    const handleSelectVersion =(change: IParsedTreeChange, index:number) =>{
      if (index==0)
        context.onSelectCurrentVersion()
      else
        selectVersion(change.id);          
    }

    const isSelected = (change: IParsedTreeChange, index:number)=>
    {
      if (context.editorStatus.selectedVersion)
      {
        return context.editorStatus.selectedVersion.id == change.id
      }
      return false
      //else if (index==0)
      //  return true;
    }
    const handleScroll = async(e: any) => {
    
      const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
      
        if (bottom && (versionsList && versionsList.length==pageSize) && !isLoading)
        {
          getParsedTreeChanges(page + pageSize);                  
          setPage(page+pageSize);                     
        }
    }

    const currentVersion=()=>{
      return (
        <S.Version  selected={!context.editorStatus.selectedVersion}  onClick={()=> context.onSelectCurrentVersion()}>          
          <div>(Current)</div>
          {new Intl.DateTimeFormat('en-US',{day:'2-digit', month:'2-digit', year:'2-digit', hour:'2-digit', minute:'2-digit'}).format(new Date())} by {authContext?.userData.profile.name ? authContext?.userData.profile.name : "Default User"}
        </S.Version>                                              
      )
    }

    const handleClose = ()=>{
      context.onSelectEditMode(true);   
    }

    return (
        <S.Root>
            <S.Header>
            <S.Title>VERSION HISTORY</S.Title>
            <S.IconContainer onClick={handleClose}>
              <SmallCloseIcon></SmallCloseIcon>            
            </S.IconContainer>
            </S.Header>
              <S.VersionsContainer onScroll={handleScroll}>                
                {
                  currentVersion()
                }
                {                  
                  versionsListView.map((data:IParsedTreeChange, index:number)=>{
                      return(                      
                        <S.Version  selected={isSelected(data,index)}  onClick={()=>selectVersion(data.id)}>{getVersionText(data)}</S.Version>                                              
                    )                        
                  })
                }                
                {isLoading && <Loading></Loading>}
              </S.VersionsContainer>
              
        </S.Root>
    );

}

export default VersionHistoryPicker;

function dispatch(arg0: any) {
    throw new Error('Function not implemented.');
}
